/*
 * Soulog customization: measure the width of the header's "usable center area" and write it to the CSS variable --soulog-header-center-width.
 *
 * Purpose: lets page sections (e.g. rich-text's "Header aligned" width) match the header menu area's width exactly —
 * i.e. clearing the logo on the left and the icon area on the right, staying aligned in real time as the window resizes.
 *
 * max(logo width, right icon area width) is used as the per-side clearance, keeping content blocks symmetrically centered:
 * when the two sides differ in width (e.g. the right-side icons are hidden), clear only by the wider side, never crossing either side's inner edge.
 *
 * This only writes the variable; whether it is used, and at which breakpoint, is decided by each section's own CSS.
 */
(function () {
	function measure(inner, logo, secondary) {
		var innerWidth = inner.clientWidth;
		if (!innerWidth) return;

		var gap = parseFloat(getComputedStyle(inner).columnGap) || 0;
		var side = Math.max(logo ? logo.offsetWidth : 0, secondary ? secondary.offsetWidth : 0);
		var center = innerWidth - 2 * (side + gap);
		if (center <= 0) return;

		document.documentElement.style.setProperty("--soulog-header-center-width", Math.round(center) + "px");
	}

	function init() {
		var inner = document.querySelector(".header .header--inner");
		if (!inner) return;

		var logo = inner.querySelector(".logolink");
		var secondary = inner.querySelector(".thb-secondary-area");
		var update = function () {
			measure(inner, logo, secondary);
		};

		update();

		// ResizeObserver covers both window resizing and size changes after the logo image loads; falls back to the resize event when unsupported.
		if (window.ResizeObserver) {
			var observer = new ResizeObserver(update);
			observer.observe(inner);
			if (logo) observer.observe(logo);
			if (secondary) observer.observe(secondary);
		} else {
			window.addEventListener("resize", update);
			window.addEventListener("load", update);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
